import { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router'
import { RequireAdmin } from './components/admin/ui.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import Layout, { PageEffects } from './components/Layout.jsx'
import { clearChunkReloadMark } from './lib/lazyChunk.js'
import AboutPage from './pages/AboutPage.jsx'
import AdminCatsPage from './pages/admin/AdminCatsPage.jsx'
import AdminFeederNewPage from './pages/admin/AdminFeederNewPage.jsx'
import AdminFeederPage from './pages/admin/AdminFeederPage.jsx'
import AdminFeedersPage from './pages/admin/AdminFeedersPage.jsx'
import AdminFinancePage from './pages/admin/AdminFinancePage.jsx'
import AdminHealthPage from './pages/admin/AdminHealthPage.jsx'
import CatPage from './pages/CatPage.jsx'
import CatsPage from './pages/CatsPage.jsx'
import ContactPage from './pages/ContactPage.jsx'
import DonatePage from './pages/DonatePage.jsx'
import LeaderboardPage from './pages/LeaderboardPage.jsx'
import FeedersPage from './pages/FeedersPage.jsx'
import HomePage from './pages/HomePage.jsx'
import LivePage, { LiveRedirect } from './pages/LivePage.jsx'
import LoginPage from './pages/LoginPage.jsx'
import ProfilePage, { RequireUser } from './pages/ProfilePage.jsx'
import RanksPage from './pages/RanksPage.jsx'
import SpotsPage from './pages/SpotsPage.jsx'
import ThanksPage from './pages/ThanksPage.jsx'
import TransparencyPage from './pages/TransparencyPage.jsx'
import NotFoundPage from './pages/states.jsx'
import VideosPage from './pages/VideosPage.jsx'

export default function App() {
  const { pathname } = useLocation()

  // Приложение доехало до рендера — значит части сборки на месте. Снимаем
  // отметку, чтобы следующая выкладка снова имела право на одну перезагрузку.
  useEffect(() => {
    clearChunkReloadMark()
    // Приложение отрисовалось — значит прошлое падение корня было разовым, и
    // следующая вкладка снова имеет право на одну автоперезагрузку.
    try {
      sessionStorage.removeItem('urbanpurr.rootRecover')
    } catch {
      // приватный режим — неважно
    }
  }, [])

  return (
    <>
      <PageEffects />
      {/* Граница ошибок ВНУТРИ роутера и со сбросом по маршруту: упавшая
          страница не должна гасить весь сайт до перезагрузки — уход на другой
          маршрут возвращает приложение к жизни. */}
      <ErrorBoundary resetKey={pathname}>
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route element={<Layout />}>
          <Route path="live" element={<LiveRedirect />} />
          <Route path="feeders" element={<FeedersPage />} />
          <Route path="feeders/:slug" element={<LivePage />} />
          <Route path="cats" element={<CatsPage />} />
          <Route path="cats/:id" element={<CatPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="donate" element={<DonatePage />} />
          <Route path="thanks" element={<ThanksPage />} />
          <Route path="transparency" element={<TransparencyPage />} />
          <Route path="ranks" element={<RanksPage />} />
          <Route path="leaderboard" element={<LeaderboardPage />} />
          <Route path="spots" element={<SpotsPage />} />
          <Route path="profile" element={<RequireUser><ProfilePage /></RequireUser>} />
          <Route path="videos" element={<RequireUser><VideosPage /></RequireUser>} />
          <Route path="admin" element={<RequireAdmin><AdminFeedersPage /></RequireAdmin>} />
          <Route path="admin/feeders/new" element={<RequireAdmin><AdminFeederNewPage /></RequireAdmin>} />
          <Route path="admin/feeders/:slug" element={<RequireAdmin><AdminFeederPage /></RequireAdmin>} />
          <Route path="admin/cats" element={<RequireAdmin><AdminCatsPage /></RequireAdmin>} />
          <Route path="admin/finance" element={<RequireAdmin><AdminFinancePage /></RequireAdmin>} />
          <Route path="admin/health" element={<RequireAdmin><AdminHealthPage /></RequireAdmin>} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      </ErrorBoundary>
    </>
  )
}
